export default __webpack_public_path__ + "static/backgroundWhiteStatic-9d19c4ccd0f279a362c3d5361dbbc5b9.webp";